<template>
  <div style="margin-bottom: 170px">
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group w-702px mr-5">
        <div class="prepend-icon"><v-icon>search</v-icon></div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />
      </div>
      <TableControlShowState v-model="filter.status"></TableControlShowState>
      <button class="btn btn-primary w-88px" @click="getBus">搜尋</button>
    </div>

    <!-- table -->
    <div class="table">
      <div class="table-head">
        <!-- column head -->
        <div
          v-if="lengthOfisCheckedList == 0"
          class="form-item d-flex px-5 h-60px align-center"
        >
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="col-buname">BU Name</h5>
          <h5 class="col-order">Order</h5>
          <h5 class="col-show ml-auto">顯示/隱藏</h5>
          <h5 class="col-edit">編輯</h5>
          <h5 class="col-delete">刪除</h5>
        </div>
        <!-- column action -->
        <div v-else class="form-item d-flex align-center px-5 h-60px">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div><button class="btn mr-10px" @click="changePublish(true)">設為顯示</button></div>
          <div><button class="btn" @click="changePublish(false)">設為隱藏</button></div>
        </div>
      </div>
      <div class="table-body">
        <div
          class="form-item d-flex h-60px align-center"
          v-for="item in bus"
          :key="item.id"
        >
          <div class="h5 col-checkbox">
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </div>
          <div class="h5 col-buname">{{ item.name }}</div>
          <div class="h5 col-order text-right">{{ item.order }}</div>
          <div class="h5 col-show ml-auto d-flex align-center">
            <FormSwitch v-model="item.status"
                        @changeStatus="changePublish(item.status, item.id)">
            </FormSwitch>
          </div>
          <div class="h5 col-edit ">
            <button class="btn square" @click="toBUPageEdit(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </div>
          <div class="h5 col-delete">
            <deleteDialog
              @confirm-delete="deleteItem(item.id)"
              :disabled="item.id <= 6">
            </deleteDialog>
          </div>
        </div>
      </div>
    </div>

    <!-- table footer -->
    <Pagination @handleNextPreEvent="getBus" model="bupage"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    TableControlShowState,
    FormSwitch,
    Pagination,
    deleteDialog,
  },
  data: () => ({
    checkAllStatus: false, // left top checkbox status
  }),
  computed: {
    ...mapState('bupage', ['bus', 'filter']),
    lengthOfisCheckedList() {
      return this.bus.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.bus.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.bus.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.bus.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.bus.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.bus.length) {
        this.checkAllStatus = true;
      }
      if (this.bus.length === 0) {
        this.checkAllStatus = false;
      }
    },
  },
  methods: {
    ...mapActions('bupage', {
      clear: 'clear',
      getBus: 'find',
      setBus: 'setBus',
      deleteBu: 'destroy',
      publish: 'publish',
    }),
    toBUPageEdit(id) {
      this.$router.push({
        name: 'BUPageEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.bus.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.bus.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.deleteBu(id).then(() => {
        this.getBus();
      });
    },
    changePublish(status, id) {
      this.publish({
        ids: id ? [id] : this.isCheckedListIds,
        status,
      }).then(() => {
        this.getBus();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-buname {
    min-width: 200px;
  }
  .col-order {
    width: 40px;
  }
  .col-show {
    margin-right: 40px;
  }
}
</style>
